import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';


@Directive({
  selector: '[fileDropZone]'
})
export class DropzoneDirective{

  @Output('fileDrop') fileDrop = new EventEmitter<any>();
  
  @HostListener('dragover', ['$event']) onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = true;
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = false;
  }

  @HostListener('drop', ['$event']) onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer.files;
    if(files.length > 0){
      this.fileDrop.emit(files);
    }
    this.opacity = false;
  }

  @HostBinding('class.opacity') opacity: boolean;
}

